module.exports = __webpack_public_path__ + "static/img/11.2597e72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/health/11.png
// module id = NXi7
// module chunks = 1